export default __webpack_public_path__ + "static/media/ts-5-4.44064870.svg";